import { Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { throwError } from "rxjs";
import { catchError, map } from "rxjs/operators";

import { environment } from "environments/environment";

import { Country } from "@common/models/country";
import { TranslateService } from "@ngx-translate/core";
import { Column, DataTableInput, DataTableOutput, Order, Search } from "@core/models/datables";

@Injectable({ providedIn: "root" })
export class CountryService {

  private columns: Column[] = [
    {
      data: "id",
      name: "ID",
      searchable: true,
      orderable: true,
      search: new Search()
    },
    {
      data: "name",
      name: "Name",
      searchable: true,
      orderable: true,
      search: new Search()
    },
    {
      data: "nameEnglish",
      name: "NameEnglish",
      searchable: true,
      orderable: true,
      search: new Search()
    },
  ];

  constructor(private _http: HttpClient) { }

  // Create a data table input object for request
  private createDataTableInput(page: number, quantity: number, order: Order, searchText: string): DataTableInput {
    let input = new DataTableInput();
    input.start = page * quantity;
    input.length = quantity;
    if (searchText !== "") {
      input.search.regex = true;
      input.search.value = searchText;
    }
    if (order) {
      input.order.push(order);
    }
    input.columns = this.columns;
    return input;
  }

  getAll() {
    return this._http.get<Country[]>(
      `${environment.commonApiUrl}/api/country`
    );
  }

  getLiteByName(name: string) {
    return this._http.get<Country[]>(`${environment.commonApiUrl}/api/country/lite/${name}`);
  }

  getAllIndex(page: number, quantity: number, order: Order, searchText: string) {
    const input = this.createDataTableInput(page, quantity, order, searchText);
    return this._http.post<DataTableOutput<Country>>(`${environment.commonApiUrl}/api/country/index`, input);
  }
}
